// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2_BRI","select":"Header_select__2B8Dm","clinic":"Header_clinic__bWyTJ"};